export default __webpack_public_path__ + "static/media/WhiteDocumentCheck.c480c9d4.svg";